import React from 'react'
import { Button, Form, Input, Modal, message } from 'antd'
import TableAPI from '../../../components/TableAPI'
import { columns } from './columns'
import API from '../../../../utils/api'
import { useToken } from '../../../hooks'
import { View } from '../../../../styles/reactnative'

const AdminProcessSetting = () => {
	const [modalVisible, setModalVisible] = React.useState(false)
	const [process, setProcess] = React.useState('')
	const { data: token } = useToken()

	return (
		<>
			<TableAPI
				pairreplace={false}
				resulttype="result"
				title={'제한 프로그램 관리'}
				columns={columns}
				usermodal={false}
				height={'default'}
				apikey={`/admin/process?tt=`}
				pagination={false}
				action={mutate => {
					return (
						<Button
							type="primary"
							onClick={() => {
								setModalVisible(true)
							}}>
							프로세스 등록
						</Button>
					)
				}}
				actionmodal={mutate => {
					return (
						<Modal
							title="제한프로그램 등록"
							visible={modalVisible}
							okText="등록"
							cancelText="취소"
							onOk={() => {
								API.send('POST', '/admin/process', token + '', {
									process: process,
								}).then(res => {
									message.success('등록되었습니다.')
									mutate(1)
								})
								setModalVisible(false)
							}}
							onCancel={() => {
								setModalVisible(false)
							}}>
							<Input
								value={process}
								onChange={e => setProcess(e.target.value)}
								placeholder="제한프로그램 (ex: notepad.exe)"
							/>
						</Modal>
					)
				}}
			/>
		</>
	)
}

export default React.memo(AdminProcessSetting)
